// A/B Upgrade-Copy Experiment
// Each visitor is randomly (and persistently) assigned variant "A" or "B".
// The variant drives the copy shown in UpgradePromptDialog and is tagged onto
// every paywall analytics event so the SuperAdmin card can compare CTR.

const VARIANT_KEY = 'lumera_upgrade_variant';

/** Return this visitor's persisted A/B variant, assigning one on first call. */
export const getUpgradeVariant = () => {
  try {
    let v = localStorage.getItem(VARIANT_KEY);
    if (v !== 'A' && v !== 'B') {
      v = Math.random() < 0.5 ? 'A' : 'B';
      localStorage.setItem(VARIANT_KEY, v);
    }
    return v;
  } catch {
    return 'A';
  }
};

/**
 * Copy for the free-user upgrade paywall, per variant.
 *  A = feature-benefit framing ("Unlock <feature>")
 *  B = price framing ("Go Premium — $4.99/mo")
 */
export const getUpgradeCopy = (variant, feature, es) => {
  const feat = feature || (es ? 'Esta función' : 'This feature');
  if (variant === 'B') {
    return {
      title: es ? 'Hazte Premium — $4.99/mes' : 'Go Premium — $4.99/mo',
      description: es
        ? `${feat} está incluido en Lumera+. Menos que un café al mes por números de Strong, comentarios, diccionarios, mapas y más.`
        : `${feat} is included with Lumera+. Less than a coffee a month for Strong’s numbers, commentaries, dictionaries, maps, and more.`,
      cta: es ? 'Comenzar por $4.99/mes' : 'Start for $4.99/mo',
    };
  }
  return {
    title: es ? `Desbloquea ${feature ? feature : 'con Lumera+'}` : `Unlock ${feature || 'with Lumera+'}`,
    description: es
      ? `${feat} es una función Premium. Actualiza para acceder a números de Strong, comentarios, diccionarios, mapas y más.`
      : `${feat} is a Premium feature. Upgrade to access Strong’s numbers, commentaries, dictionaries, maps, and more.`,
    cta: es ? 'Ver planes · Prueba gratis' : 'See plans · Start free trial',
  };
};
